/* eslint-disable import/no-cycle */
import { useCallback } from 'react';
import { QuestionnaireTemplateStore } from '../../store/questionnaireTemplateModel';
import { optionTextSchema } from '../errorHandlers/formValidation.schema';

interface UpdateOptionValueParams {
  elementId: string;
  optionId: string;
  value: string;
  hasInteracted: boolean;
}

type UpdateOptionAction = (params: UpdateOptionValueParams) => void;

function buildErrorKey(elementId: string, optionId: string): string {
  return `${elementId}.options.${optionId}.text`;
}

export function useUpdateOptionValue(): UpdateOptionAction {
  const updateOption = QuestionnaireTemplateStore.useStoreActions((a) => a.updateOptionText);
  const setFieldError = QuestionnaireTemplateStore.useStoreActions((a) => a.setFieldError);
  const clearFieldError = QuestionnaireTemplateStore.useStoreActions((a) => a.clearFieldError);

  return useCallback(
    ({ elementId, optionId, value, hasInteracted }: UpdateOptionValueParams): void => {
      updateOption({ elementId, optionId, value });

      if (!hasInteracted) return;

      const errorKey = buildErrorKey(elementId, optionId);
      const { error } = optionTextSchema.validate(value);

      if (error) {
        const [detail] = error.details;
        setFieldError({ key: errorKey, error: { message: detail.message, context: detail.context } });
      } else {
        clearFieldError(errorKey);
      }
    },
    [updateOption, setFieldError, clearFieldError],
  );
}
